import React from "react";

import Box from "@mui/material/Box";
import FeaturedProduct from "./FeaturedProduct";
import { HashLink } from "react-router-hash-link";
import { useProductContext } from "../../../context/ProductContext";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import CurrencyFormat from "react-currency-format";

const FeaturedProductRecent = ({ currentLocation }) => {
  const { t, i18n } = useTranslation();
  const viewed = sessionStorage.getItem("viewed");
  const { products } = useProductContext();

  // console.log("viewed", viewed);

  let arr;
  if (viewed && viewed.length > 0) {
    arr = viewed.split("/");
    arr = arr.filter(function (item) {
      return parseInt(item) == item;
    });
    arr = arr.reverse();
    // console.log(arr);
  }

  if (arr && arr.length > 0) {
    return (
      <Box
        sx={{
          width: { md: 9 / 10, sm: 1 },
          ml: "auto",
          mr: "auto",
          mb: 10,
          mt: 5,
        }}
      >
        <Box
          sx={{
            textAlign: "left",
            pl: 6,
            fontSize: "17px",
          }}
        >
          {t("Your Recents")}
          {/* <Box
            sx={{
              borderBottom: "5px solid #f3756d",
              width: "40px",
              paddingBottom: "20px",
            }}
          ></Box> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            container
            sx={{
              mt: 4,
            }}
          >
            {arr?.map((idx, index) => {
              if (index < 4 && products[idx]) {
                return (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    md={3}
                    sm={6}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <HashLink to={"/product/" + products[idx].linkTo + "#top"}>
                      <Box sx={{ padding: "30px", backgroundColor: "#f8f7f5" }}>
                        <img
                          src={products[idx].img}
                          className="animation"
                          width="130"
                          height="130"
                        />
                      </Box>
                      <Box sx={{ pt: 1, color: "#757575" }}>It's All Good</Box>{" "}
                      <Box
                        sx={{
                          mt: 1,
                          fontSize: "11px",
                          height: "30px",
                          minWidth: "230px",
                          maxWidth: "230px",
                        }}
                      >
                        {t(products[idx].title)}
                      </Box>
                      <Box sx={{ mt: 1, fontSize: "16px", fontWeight: 600 }}>
                        {currentLocation === "KO" ? (
                          <CurrencyFormat
                            value={products[idx].price_KO}
                            displayType={"text"}
                            thousandSeparator={true}
                            suffix={"원"}
                          />
                        ) : (
                          <CurrencyFormat
                            decimalScale={2}
                            value={products[idx].price_US}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                        )}
                      </Box>
                    </HashLink>
                  </Grid>
                );
              }
            })}
          </Grid>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};
{
  /* <FeaturedProduct
            img={products[idx].img}
            title={products[idx].title}
            subtitle={products[idx].subtitle}
            price={products[idx].price}
          /> */
}
export default FeaturedProductRecent;
